/* NAS Solutions section behaviour. Vanilla, no dependencies. */
(function () {
  "use strict";

  function init(root) {
    if (!root || root.dataset.nasReady === "1") return;
    root.dataset.nasReady = "1";

    /* ---- use-case selector ---- */
    var chips = root.querySelectorAll(".nas__chip");
    var panels = root.querySelectorAll(".nas__panel");
    function activate(key) {
      chips.forEach(function (c) {
        c.classList.toggle("is-active", c.getAttribute("data-key") === key);
      });
      panels.forEach(function (p) {
        p.classList.toggle("is-active", p.getAttribute("data-key") === key);
      });
    }
    chips.forEach(function (c) {
      c.addEventListener("click", function () {
        activate(c.getAttribute("data-key"));
      });
    });

    /* ---- smooth scroll for in-page CTAs ---- */
    root.querySelectorAll('a[data-nas-scroll]').forEach(function (a) {
      a.addEventListener("click", function (e) {
        var sel = a.getAttribute("href");
        if (!sel || sel.charAt(0) !== "#") return;
        var t = root.querySelector(sel) || document.querySelector(sel);
        if (t) {
          e.preventDefault();
          t.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    });

    /* ---- lead form: honeypot + time-trap + light validation ---- */
    var form = root.querySelector(".nas__form");
    if (form) {
      var started = Date.now();
      var tstamp = form.querySelector('input[name="contact[__elapsed]"]');
      var err = form.querySelector(".nas__err");
      form.addEventListener("submit", function (e) {
        if (tstamp) tstamp.value = String(Math.round((Date.now() - started) / 1000));
        var hp = form.querySelector(".nas__hp input");
        if (hp && hp.value.trim() !== "") {
          e.preventDefault();
          return;
        }
        if (Date.now() - started < 3000) {
          e.preventDefault();
          if (err) err.textContent = "Please take a moment to complete the form, then submit again.";
          return;
        }
        var email = form.querySelector('input[type="email"]');
        if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) {
          e.preventDefault();
          if (err) err.textContent = "Please enter a valid email address.";
          email.focus();
          return;
        }
        var btn = form.querySelector('button[type="submit"]');
        if (btn) {
          btn.disabled = true;
          btn.textContent = "Sending...";
        }
      });
    }
  }

  function boot() {
    document.querySelectorAll(".nas").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  /* Re-init inside the Shopify theme editor */
  document.addEventListener("shopify:section:load", function (e) {
    var el = e.target.querySelector(".nas");
    if (el) init(el);
  });
})();
